export const defaultAccommodationRoom = {
    adults: 2,
    children: 0,
    childrenAges: []
};
export const defaultAccommodation = {
    rooms: [
        defaultAccommodationRoom
    ]
};
export const defaultRestrictions = {
    adults: {
        min: 0,
        max: 9,
        value: 1
    },
    children: {
        min: 0,
        max: 9,
        value: 1,
        maxAge: 17
    }
};

//# sourceMappingURL=constants.js.map